const { VITE_APP_SAS_URL, VITE_APP_SECURE_AD_SERVER } = import.meta.env;

function buildCreateDealURL(createUrl, accountName) {
  return `${VITE_APP_SAS_URL}/${VITE_APP_SECURE_AD_SERVER}/${accountName}/${createUrl}`;
}

function buildListingDealURL(listingUrl, accountName) {
  return `${VITE_APP_SAS_URL}/${VITE_APP_SECURE_AD_SERVER}/${accountName}/${listingUrl}`;
}

function buildDemandOverviewMetricUrl(listingUrl, metric) {
  if (!listingUrl || !metric?.filters) return listingUrl;

  const params = new URLSearchParams({
    filters: JSON.stringify(metric.filters),
  });
  const separator = listingUrl.includes('?') ? '&' : '?';

  return `${listingUrl}${separator}${params.toString()}`;
}

export { buildCreateDealURL, buildListingDealURL, buildDemandOverviewMetricUrl };
